<div class="lhc-item-display">
  <lhc-item-question-text [item]="item"></lhc-item-question-text>
</div>